import { createSlice } from "@reduxjs/toolkit";
import { IBlog } from "../../../Common/Api/BlogApi/Interfaces/Blog";
import { deleteBlogBuilder } from "./BlogDelete";
import { getBlogBuilder } from "./BlogGet";
import { patchBlogBuilder } from "./BlogPatch";
import { postBlogBuilder } from "./BlogPost";

export const initialState: IBlog = {
    active: false,
    content: "",
    poster: {
        username: "",
    },
    publish_date: "",
    tags: [],
    slug: "",
    title: "",
    title_image: { image: "", url: "", thumbnail_100: "", thumbnail_200: "", },
    url: "",
    id: null,

    validation_errors: {
        active: [], title: [], title_image: [], slug: [], content: [], publish_date: [], poster: [], url: [], tags: [],
    },

    request_states: {
        get: { pending: false, fulfilled: false, rejected: false, error_description: "", },
        post: { pending: false, fulfilled: false, rejected: false, error_description: "", },
        patch: { pending: false, fulfilled: false, rejected: false, error_description: "", },
        delete: { pending: false, fulfilled: false, rejected: false, error_description: "", },
    }
}

export const BlogSlice = createSlice({
    name: "blog", initialState,
    reducers: {
        reset: (state) => { return { ...state, ...initialState, } },
        update: (state, action) => { return { ...state, ...action.payload, } },
        resetValidationErrors: (state) => {
            // redux toolkit uses immer internally
            state.validation_errors = initialState.validation_errors;
            return state;
        },
        updateValidationErrors: (state, action) => {
            return {
                ...state,
                validation_errors: {
                    ...state.validation_errors,
                    ...action.payload,
                }
            }
        },
        resetPatchState: (state) => { state.request_states.patch = initialState.request_states.patch; },
        resetGetState: (state) => { state.request_states.get = initialState.request_states.get; },
        resetPostState: (state) => { state.request_states.post = initialState.request_states.post; },
        resetDeleteState: (state) => { state.request_states.delete = initialState.request_states.delete; },
    },
    extraReducers: builder => {
        postBlogBuilder(builder);
        getBlogBuilder(builder);
        patchBlogBuilder(builder);
        deleteBlogBuilder(builder);
    }
})

export const {
    update, reset, resetGetState, resetPatchState, resetPostState, resetValidationErrors, updateValidationErrors, resetDeleteState,
} = BlogSlice.actions;

export * from "./BlogPost";
export * from "./BlogGet";
export * from "./BlogPatch";
export * from "./BlogDelete";

export default BlogSlice.reducer;
